var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.currentLocation)?_c('l-marker',{attrs:{"lat-lng":_vm.currentLocation}},[_c('l-icon',{attrs:{"icon-size":[20, 40],"icon-anchor":[10, 40]}},[_c('div',[_c('v-icon',{staticClass:"current-location",attrs:{"x-large":"","color":"warning"}},[_vm._v(" mdi-map-marker ")])],1)])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }